import {
  breakpointMedium,
  breakpointLarge,
  breakpointExtraLarge,
} from '../design-tokens/breakpoints';

const numColumnsMobileTotal = 4;
const numColumnsDesktopTotal = 12;
const paddingMobile = '32px';
const paddingDesktop = '48px';
const halfGutterWidth = '8px';

export const columnWidth = (
  numColumnsMobile: number,
  numColumnsTablet: number,
  numColumnsDesktop: number,
) => `
  width: ${
    numColumnsMobile >= numColumnsMobileTotal
      ? `100vw;`
      : `calc((100vw - ${paddingMobile}) * (${numColumnsMobile} / ${numColumnsMobileTotal}) - ${halfGutterWidth});`
  }
  @media (min-width: ${breakpointMedium.start}) {
    width: calc((100vw - ${paddingDesktop}) * (${numColumnsTablet} / ${numColumnsDesktopTotal}) - ${halfGutterWidth});
  }
  @media (min-width: ${breakpointLarge.start}) {
    width: calc((100vw - ${paddingDesktop}) * (${numColumnsDesktop} / ${numColumnsDesktopTotal}) - ${halfGutterWidth});
  }
  @media (min-width: ${breakpointExtraLarge.start}) {
    width: calc((${
      breakpointExtraLarge.start
    } - ${paddingDesktop}) * (${numColumnsDesktop} / ${numColumnsDesktopTotal}) - ${halfGutterWidth});
  }
  `;
